import { render, staticRenderFns } from "./llw.vue?vue&type=template&id=1f4c9c7c&scoped=true&"
var script = {}
import style0 from "./llw.vue?vue&type=style&index=0&id=1f4c9c7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4c9c7c",
  null
  
)

export default component.exports